module.exports = __webpack_public_path__ + "static/1284549946.60273677.jpg";